import type { RouteRecordRaw } from 'vue-router';

import { routes as catalogRoutes } from '@/features/catalog';
import { routes as registrationRoutes } from '@/features/registration';
import { routes as bidRoutes } from '@/features/bid';
import { routes as myBidsRoutes } from '@/features/my-bids';
import { routes as checkoutRoutes } from '@/features/checkout';
import { routes as recoveryRoutes } from '@/features/recovery';
import { routes as wishlistRoutes } from '@/features/wishlist';
import { routes as winsRoutes } from '@/features/wins';
import { routes as accountRoutes } from '@/features/account';
import { routes as unsubscribeRoutes } from '@/features/unsubscribe';

/**
 * Declarative list of features mounted in this shell. Per the
 * split-readiness rules in `docs/architecture/frontend-structure.md` §2.1,
 * each entry's `routes` is the feature's barrel export — never imported
 * from a feature sub-path. Adding a feature is a registry edit; removing
 * a feature is a registry edit.
 */
export interface FeatureModule {
  name: string;
  routes: RouteRecordRaw[];
}

const features: FeatureModule[] = [
  { name: 'catalog', routes: catalogRoutes },
  { name: 'registration', routes: registrationRoutes },
  { name: 'bid', routes: bidRoutes },
  { name: 'my-bids', routes: myBidsRoutes },
  { name: 'checkout', routes: checkoutRoutes },
  { name: 'recovery', routes: recoveryRoutes },
  { name: 'wishlist', routes: wishlistRoutes },
  { name: 'wins', routes: winsRoutes },
  { name: 'account', routes: accountRoutes },
  { name: 'unsubscribe', routes: unsubscribeRoutes },
  // activation: overlay-only — no routes; mounted via ActivationGateMount in App.vue
];

export function registeredFeatures(): readonly FeatureModule[] {
  return features;
}

export function aggregateFeatureRoutes(): RouteRecordRaw[] {
  return features.flatMap((f) => f.routes);
}
